import axios from 'axios';
import config from '../config/config';

const apiUrl = config.apiBaseUrl;

/**
 * Obtiene las facturas asociadas a una Orden de Compra (OC)
 */
export const getFacturasPorOC = async (idDatosErp) => {
  try {
    const res = await axios.post(`${apiUrl}/facturasPorOC`, { IDDATOSERP: idDatosErp });
    return res.data;
  } catch (err) {
    console.error('Error al obtener facturas por OC:', err);
    throw err;
  }
};

/**
 * Sincroniza/Actualiza una OC específica desde el ERP
 */
export const sincronizarOC = async (payload) => {
  try {
    const res = await axios.post(`${apiUrl}/sincronizarERP1`, payload);
    return res.data;
  } catch (err) {
    console.error('Error al sincronizar OC:', err);
    throw err;
  }
};

/**
 * Genera la solicitud de pago guardándola en la base de datos (con adjuntos)
 */
export const guardarSolicitudPago = async (formDataToSend) => {
  try {
    const res = await axios.put(`${apiUrl}/solicitudesGenerarPago`, formDataToSend, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

/**
 * Reclasifica una solicitud (solo archivos) sin generar una nueva.
 */
export const reclasificarSolicitud = async (formDataToSend) => {
  try {
    const res = await axios.post(`${apiUrl}/solicitudesReclasificar`, formDataToSend, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  } catch (err) {
    console.error('Error en reclasificarSolicitud:', err);
    throw err;
  }
};

/**
 * Actualiza la preferencia de "Requiere Factura" para un proveedor en el catálogo
 */
export const getDetalleOC = async (payload) => {
  const resp = await axios.post(`${apiUrl}/getDetalleOC`, payload);
  return resp.data;
};

export const actualizarPreferenciaProveedor = async (rfc, empresaId, requiereFactura) => {
  try {
    const res = await axios.post(`${apiUrl}/actualizarPreferenciaFacturaProveedor`, {
      rfc,
      empresaId,
      requiereFactura: !!requiereFactura
    });
    return res.data;
  } catch (err) {
    console.error('Error al actualizar preferencia de proveedor:', err);
    throw err;
  }
};
export const getPreferenciaProveedor = async (rfc, empresaId) => {
  try {
    const res = await axios.post(`${apiUrl}/getPreferenciaProveedor`, { rfc, empresaId });
    return res.data;
  } catch (err) {
    console.error('Error al obtener preferencia de proveedor:', err);
    throw err;
  }
};
